import * as React from 'react';
import { SelectableGroup } from '../../../../components/drag-select';
import { PageActionHeading } from '../../../../components/page-components/PageActionHeading';
import { OrderGroupTable } from './OrderGroupTable';

interface IProps {
    orderGroups     : any;
    onDragComplete  : any;
    showExtraData   : boolean;
}

export const OrderGroupSelectable = (props : IProps) => {

    return <SelectableGroup
                className="order-selectable"
                clickClassName="order-selectable"
                enableDeselect
                tolerance={0}
                selectOnClick={true}
                allowShiftClick={true}
                globalMouse={true}
                onSelectionFinish={ props.onDragComplete }
                allowClickWithoutSelected={true}>
                {
                    props.orderGroups && Object.keys(props.orderGroups).length > 0
                        ? Object.keys(props.orderGroups).map((item: string, outerIdx: number) =>
                            <React.Fragment key={ props.orderGroups[item].uid }>
                                <div className="row">
                                    <div className="col">
                                        <PageActionHeading
                                            id={`move-group-${outerIdx}`}
                                            heading={ 
                                                <div className="d-flex justify-content-between selectable-group-header">
                                                    <span className="group-name">
                                                    {
                                                        `Order Grouping #${ Number.parseInt(item, 10) + 1 }`
                                                    }
                                                    </span>
                                                    <div>
                                                        <p className="rollup-metric">
                                                            <span>Totals</span>
                                                        </p>
                                                        <p className="rollup-metric">
                                                            <span>Units</span>
                                                            <span>{props.orderGroups[item].rollup.units}</span>
                                                        </p>
                                                        <p className="rollup-metric">
                                                            <span>Weight</span>
                                                            <span>{props.orderGroups[item].rollup.weight}</span>
                                                        </p>
                                                        <p className="rollup-metric">
                                                            <span>Singles</span>
                                                            <span>{props.orderGroups[item].rollup.singles}</span>
                                                        </p>
                                                        <p className="rollup-metric">
                                                            <span>Feet</span>
                                                            <span>{props.orderGroups[item].rollup.feet}</span>
                                                        </p>
                                                        {
                                                            props.showExtraData
                                                                ? <React.Fragment>
                                                                    <p className="rollup-metric">
                                                                        <span>Sections</span>
                                                                        <span>
                                                                            {props.orderGroups[item].rollup.sections}
                                                                        </span>
                                                                    </p>
                                                                    <p className="rollup-metric">
                                                                        <span>Track</span>
                                                                        <span>
                                                                            {props.orderGroups[item].rollup.track}
                                                                        </span>
                                                                    </p>
                                                                    <p className="rollup-metric">
                                                                        <span>Hardware</span>
                                                                        <span>
                                                                            {props.orderGroups[item].rollup.hardware}
                                                                        </span>
                                                                    </p>
                                                                </React.Fragment>
                                                                : null
                                                        }
                                                    </div>
                                                </div>
                                            }  
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <OrderGroupTable
                                            showExtraData={ props.showExtraData }
                                            orders={props.orderGroups[item]}
                                        />
                                    </div>
                                </div>                        
                            </React.Fragment>
                        )
                        : null
                }
            </SelectableGroup>;
};
